const Skills = [
  {
    name: "React",
    img: require("../img/react.svg"),
  },
  {
    name: "Python",
    img: require("../img/python.svg"),
  },

  {
    name: "Git",
    img: require("../img/git.svg"),
  },

  {
    name: "Java",
    img: require("../img/java.svg"),
  },

  {
    name: "Spring Boot",
    img: require("../img/spring.svg"),
  },

  {
    name: "MySQL",
    img: require("../img/mysql.svg"),
  },
  {
    name: "AWS",
    img: require("../img/aws.svg"),
  },
    {
    name: "Jenkins",
    img: require("../img/jenkins.svg"),
  },
];

export default Skills;
